import {createRouter, createWebHistory} from 'vue-router'
import AdminRoutes from './admin_routes.js'
import PublicRoutes from './public_routes.js'
import {authenticationStore, defaultStore} from '@/main.js'
import {accessRules} from '@/permissions/accessControl'
import {mainMiddleware} from '@shared-utils/router/middlewares/mainMiddleware'

const routes = [
  {
    path: '/',
    name: 'index',
    children: [AdminRoutes, PublicRoutes],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return {top: 0}
  },
})

router.beforeEach(async (to, from, next) => {
  const redirectEmployeesToCrm = true
  const nextRoute = await mainMiddleware({to, defaultStore, authenticationStore, router, accessRules, redirectEmployeesToCrm})

  if (nextRoute?.external) {
    next(false)
    return
  }

  return nextRoute ? next(nextRoute) : next()
})

export default router
